import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { LazyImageComponent } from "./lazy-image.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MaterialModule,
        SharedModule,
    ],
    declarations: [LazyImageComponent],
    exports: [LazyImageComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
    
})
export class LazyImageModule {}